{
  "clubId": "default",
  "items": [],
  "count": 0,
  "maxLimit": 3
}
